import { Alert, Spinner } from "@alpacahq/ui/old";

import { AccountAgreementCardPresentation } from "./AccountAgreementCard/AccountAgreementCard.pres";
import type { AgreementsPresentationProps } from "./Agreements.controller";
import { UpdateCustomerAgreementPresentation } from "./UpdateCustomerAgreement/UpdateCustomerAgreement.pres";

export const AgreementsPresentation = (props: AgreementsPresentationProps) => {
  if (props.isLoading) {
    return (
      <div className="flex w-full max-w-[600px] justify-center pt-32">
        <Spinner />
      </div>
    );
  }

  const {
    isLatestAgreementRequired,
    isMissingSignerPartyId,
    customerAgreement,
    agreementsCard,
  } = props;

  return (
    <div className="flex w-full max-w-[600px] flex-col gap-4 overflow-y-visible">
      {isMissingSignerPartyId && (
        <Alert
          variant="warning"
          message={
            <span>
              We couldn't find the signer party ID needed to sign agreements for
              this entity. Please contact{" "}
              <a href="mailto:support@alpaca.markets" className="underline">
                support@alpaca.markets
              </a>{" "}
              for assistance.
            </span>
          }
        />
      )}
      {isLatestAgreementRequired && (
        <UpdateCustomerAgreementPresentation {...customerAgreement} />
      )}
      <AccountAgreementCardPresentation {...agreementsCard} />
    </div>
  );
};
